import { useEffect, useState } from "react";
import { Activity } from "../../../models/Activities";
import emissionFactorService from "../../../service/emissionFactor.service";
import { DROPDOWN_EMISSION_GROUP } from "../../../components/emission/emission-components";
import {
  cat3UpstreamForFactor,
  showsCat3UpstreamHint,
} from "../../../utils/emissionUtils";
import { storedDay } from "../../../utils/dateUtils";

// names the upstream list of a saved row's own stored factor, for windows where the factor is shown read-only
export const useCat3UpstreamPublisher = (
  open: boolean,
  activity: Activity | null | undefined,
): string | undefined => {
  const [upstreamPublisher, setUpstreamPublisher] = useState<string>();

  useEffect(() => {
    setUpstreamPublisher(undefined);
    const group = DROPDOWN_EMISSION_GROUP.find(
      (e) => e.emissionGroup === activity?.emissionGroup,
    );
    if (
      !open ||
      !activity ||
      !group ||
      !showsCat3UpstreamHint(activity.emissionGroup)
    )
      return;

    let current = true;
    emissionFactorService
      .getEmissionFactorsV2({
        group: group._id,
        startActivity: `${storedDay(activity.startDate)}T00:00:00.000Z`,
        endActivity: `${storedDay(activity.endDate)}T23:59:59.999Z`,
      })
      .then((factorGroups) => {
        if (current)
          setUpstreamPublisher(
            cat3UpstreamForFactor(factorGroups, activity.emissionFactorRef),
          );
      })
      .catch(() => {
        // error alert already shown by service
      });
    return () => {
      current = false;
    };
  }, [open, activity]);

  return upstreamPublisher;
};
